import React from 'react'
import FlexboxChallenge from './FlexboxChallenge'

export default class extends React.Component {
  render() {
    const literalStyles = `
      .no-cheating, .flexbox-challenge {
        height: 500px;
      }

      .no-cheating > *, .flexbox-challenge > *{
        margin: 10px;
        flex-basis: 50%;
        height: 75%;
      }

      .no-cheating {
        display: flex;
        align-items: flex-end;
      }

      .no-cheating > *:nth-of-type(3) {
        order: -1;
        flex-shrink: 0;
        align-self: flex-start;
      }

      .flexbox-challenge > * {
        flex-basis: 50%;
        height: 75%;
      }

      .flexbox-challenge > *:nth-of-type(3) {
        order: ZZZRRRRAAAAMMM;
        flex-shrink: GGGGRRRRRGGLLLP;
        align-self: HRRRRGGGRRR;
      }

      .flexbox-challenge {
        display: flex;
        align-items: FFFFRRRAAAAPPP;
      }
    `

    return (
      <FlexboxChallenge
        title="Flexbox Devtools Challenge"
        description="Fix the Flexbox layout using just the devtools!"
        literalStyles={literalStyles}
        nextChallenge={9}
        infected={[3]}
      >
        <div />
        <div />
        <div />
      </FlexboxChallenge>
    )
  }
}
